import React from 'react';

const Icon = ({ className }) => (
    <svg className={className} fill='#000' width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5C14.1284 5 16.0327 5.95797 17.3153 7.46246L19 5.77778V10.4444H14.3333L16.2064 8.5714C15.2085 7.3464 13.6995 6.55556 12 6.55556C8.99856 6.55556 6.55556 8.99778 6.55556 12H5C5 8.14067 8.13989 5 12 5ZM19 12C19 15.8601 15.8601 19 12 19C9.87164 19 7.96734 18.042 6.68468 16.5375L5 18.2222V13.5556H9.66667L7.79362 15.4286C8.7915 16.6536 10.3005 17.4444 12 17.4444C15.0014 17.4444 17.4444 15.0014 17.4444 12H19Z" fill="black"/>
    </svg>
);

export default Icon;